/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1BankId202,
  PutApiV1BankId400,
  PutApiV1BankId401,
  PutApiV1BankId404,
  PutApiV1BankId409,
  PutApiV1BankId500,
  PutApiV1BankIdMutationRequest,
  PutApiV1BankIdMutationResponse,
  PutApiV1BankIdPathParams,
} from "../../types/bankRegistroController/PutApiV1BankId.ts";
import { bankSaveResultViewModelSchema } from "../bankSaveResultViewModelSchema.ts";
import { updateBankRequestViewModelSchema } from "../updateBankRequestViewModelSchema.ts";

export const putApiV1BankIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1BankIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1BankId202Schema = z.lazy(
  () => bankSaveResultViewModelSchema,
) as unknown as ToZod<PutApiV1BankId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1BankId400Schema =
  z.any() as unknown as ToZod<PutApiV1BankId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1BankId401Schema =
  z.any() as unknown as ToZod<PutApiV1BankId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1BankId404Schema =
  z.any() as unknown as ToZod<PutApiV1BankId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1BankId409Schema =
  z.any() as unknown as ToZod<PutApiV1BankId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1BankId500Schema =
  z.any() as unknown as ToZod<PutApiV1BankId500>;

export const putApiV1BankIdMutationRequestSchema = z.lazy(
  () => updateBankRequestViewModelSchema,
) as unknown as ToZod<PutApiV1BankIdMutationRequest>;

export const putApiV1BankIdMutationResponseSchema = z.lazy(
  () => putApiV1BankId202Schema,
) as unknown as ToZod<PutApiV1BankIdMutationResponse>;
